import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {TrackingEvent} from '@common/tracking-events'
import {Button} from '@components/common/base/buttons'
import {Tracking} from '../../../common/tracking'
import {setDisplayName} from '../../../common/utils-ui'
import {Checkbox} from '../common/base/checkbox'
import {BillingProps, calcTotal} from './billing-base'

export const BillingPayCard = (props: BillingProps) => {
  const {license, onChange, onPayCard, paymentStatus} = props
  const bem = Util.bemFrom('billing')
  const total = calcTotal(props)
  const toggleRecurrent = () => {
    void Tracking.send(TrackingEvent.billingToggleRecurrent)
    onChange({...license, recurrent: !license.recurrent})
  }
  const showProlong =
    license.type !== 'add-users' &&
    (!paymentStatus.subscriptions ||
      !paymentStatus.subscriptions.all ||
      paymentStatus.subscriptions.all.length === 0)
  return (
    <div
      className={bem('pay-block', {
        card: true,
        hide: license.paymentMethod !== 'card'
      })}
    >
      <div className={bem('pay-card', 'title')}>{Lang.msg.billingPayment}</div>
      <div className={bem('pay-total')}>
        {Lang.msg.billingTotal}:
        <div className={bem('pay-amount')}>
          {total || '—'} <div className={bem('pay-rub')}>{Lang.msg.rub}</div>
        </div>
      </div>
      {showProlong && (
        <div className={bem('pay-card', 'prolong')} onClick={toggleRecurrent}>
          <Checkbox
            value={license.recurrent}
            text={Lang.msg.billingAutoRenew}
          />
        </div>
      )}
      <Button disabled={license.wait} className="mt-16" onClick={onPayCard}>
        {Lang.msg.billingPay}
      </Button>
    </div>
  )
}
setDisplayName(BillingPayCard, 'BillingPayCard')
